// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes wallet-transfer-skeleton-shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.wallet-transfer-balance-skeleton {
  display: inline-block;
  vertical-align: middle;
  width: 120px;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #2a2e36 0%, #3a3f4a 45%, #2a2e36 90%);
  background-size: 200% 100%;
  animation: wallet-transfer-skeleton-shimmer 1.35s ease-in-out infinite;
}

body.light_theme .wallet-transfer-balance-skeleton {
  background: linear-gradient(90deg, #e8eaed 0%, #f1f5f9 45%, #e8eaed 90%);
  background-size: 200% 100%;
  animation: wallet-transfer-skeleton-shimmer 1.35s ease-in-out infinite;
}

.wallet-transfer-amount-error {
  margin: 8px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #f6465d;
}

.wallet-transfer-amount--error {
  border-color: #f6465d !important;
}

.wallet-transfer-amount--error input[type="number"] {
  color: #f6465d;
}

/* Custom Dropdown Styles for Funds Transfer */
.wallet-transfer-custom-select {
  width: 100%;
  border: none;
  background-color: transparent;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: inherit;
  font-size: 14px;
}

.wallet-transfer-custom-select i {
  color: #94a3b8;
  font-size: 16px;
}

.wallet-transfer-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  z-index: 1055;
}

/* Hide number input spinner for amount field */
.price_max_total input[type="number"]::-webkit-outer-spin-button,
.price_max_total input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.price_max_total input[type="number"] {
  -moz-appearance: textfield;
}

/* Coin Search Input inside Transfer Modal Dropdown */
.wallet-transfer-search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #4b515d54;
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  background-color: #232730;
  color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.wallet-transfer-search-input:focus {
  border-color: #d1aa673d;
  box-shadow: 0 0 0 1px rgba(209, 170, 103, 0.15);
}

.wallet-transfer-search-input::placeholder {
  color: #6b7280;
}

/* Light theme overrides */
body.light_theme .wallet-transfer-search-input {
  background-color: #ffffff;
  border-color: #d1d5db;
  color: #1f2937;
}

body.light_theme .wallet-transfer-search-input:focus {
  border-color: #D1AA67;
  box-shadow: 0 0 0 2px rgba(209, 170, 103, 0.15);
}

body.light_theme .wallet-transfer-search-input::placeholder {
  color: #9ca3af;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/WalletPage/walletTransferModal.css"],"names":[],"mappings":"AAAA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,wEAAwE;EACxE,0BAA0B;EAC1B,sEAAsE;AACxE;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,sEAAsE;AACxE;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA,+CAA+C;AAC/C;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qDAAqD;AACrD;EACE,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,cAAc;AAChB","sourcesContent":["@keyframes wallet-transfer-skeleton-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n.wallet-transfer-balance-skeleton {\n  display: inline-block;\n  vertical-align: middle;\n  width: 120px;\n  height: 14px;\n  border-radius: 4px;\n  background: linear-gradient(90deg, #2a2e36 0%, #3a3f4a 45%, #2a2e36 90%);\n  background-size: 200% 100%;\n  animation: wallet-transfer-skeleton-shimmer 1.35s ease-in-out infinite;\n}\n\nbody.light_theme .wallet-transfer-balance-skeleton {\n  background: linear-gradient(90deg, #e8eaed 0%, #f1f5f9 45%, #e8eaed 90%);\n  background-size: 200% 100%;\n  animation: wallet-transfer-skeleton-shimmer 1.35s ease-in-out infinite;\n}\n\n.wallet-transfer-amount-error {\n  margin: 8px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #f6465d;\n}\n\n.wallet-transfer-amount--error {\n  border-color: #f6465d !important;\n}\n\n.wallet-transfer-amount--error input[type=\"number\"] {\n  color: #f6465d;\n}\n\n/* Custom Dropdown Styles for Funds Transfer */\n.wallet-transfer-custom-select {\n  width: 100%;\n  border: none;\n  background-color: transparent;\n  padding: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: inherit;\n  font-size: 14px;\n}\n\n.wallet-transfer-custom-select i {\n  color: #94a3b8;\n  font-size: 16px;\n}\n\n.wallet-transfer-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 100%;\n  z-index: 1055;\n}\n\n/* Hide number input spinner for amount field */\n.price_max_total input[type=\"number\"]::-webkit-outer-spin-button,\n.price_max_total input[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.price_max_total input[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n/* Coin Search Input inside Transfer Modal Dropdown */\n.wallet-transfer-search-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #4b515d54;\n  border-radius: 6px;\n  font-size: 13px;\n  outline: none;\n  background-color: #232730;\n  color: #ffffff;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.wallet-transfer-search-input:focus {\n  border-color: #d1aa673d;\n  box-shadow: 0 0 0 1px rgba(209, 170, 103, 0.15);\n}\n\n.wallet-transfer-search-input::placeholder {\n  color: #6b7280;\n}\n\n/* Light theme overrides */\nbody.light_theme .wallet-transfer-search-input {\n  background-color: #ffffff;\n  border-color: #d1d5db;\n  color: #1f2937;\n}\n\nbody.light_theme .wallet-transfer-search-input:focus {\n  border-color: #D1AA67;\n  box-shadow: 0 0 0 2px rgba(209, 170, 103, 0.15);\n}\n\nbody.light_theme .wallet-transfer-search-input::placeholder {\n  color: #9ca3af;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
